<template>
  <b-modal
    id="apply-boots-token-modal"
    hide-footer
    size="sm"
    centered
    @hide="hideModal"
  >
    <template #modal-title>
      <div class="d-flex align-items-center">
        <span class="font-weight-bold">Apply Boost Tokens</span>
        <b-icon-gift class="ml-1 text-primary"></b-icon-gift>
      </div>
    </template>

    <!-- Subtitle -->
    <div class="text-center mb-1">
      <h5 class="font-weight-bold mb-0 text-black">Select Odds Boost</h5>
      <small class="text-muted">
        Choose from available boost templates to apply.
      </small>
    </div>

    <!-- Select -->
    <b-form-group label="Deposit Match" label-class="text-black">
      <b-form-select v-model="option" :options="options" />
    </b-form-group>

    <!-- Type -->
    <b-form-group label="Type" class="text-black">
      <b-form-input v-model="type" disabled />
    </b-form-group>

    <!-- Amount -->
    <b-form-group label="Amount" class="text-black">
      <b-form-input v-model="amount" disabled />
    </b-form-group>

    <!-- Description -->
    <b-form-group label="Description" class="text-black">
      <b-form-textarea
        v-model="description"
        placeholder="Description will appear after deposit match selected"
        disabled
        rows="3"
      />
    </b-form-group>

    <div class="d-flex justify-content-between text-black">
      <span>User:</span>
      <span>{{ itemSelected.recurrence }}</span>
      <b-button
        size="sm"
        variant="outline-primary"
        class="mr-1"
        @click="$refs.tagRef.show()"
        :disabled="!option"
      >
        Set Recurrence
      </b-button>
    </div>

    <!-- Buttons -->
    <b-button
      block
      variant="success"
      class="mb-1 mt-2"
      @click="handleApplyPromotion"
      :disabled="loadingCreatePromotion || !option"
    >
      <Spinner v-if="loadingCreatePromotion" />
      <template v-else> APPLY BOOST TOKENS</template>
    </b-button>

    <b-button block variant="outline-secondary" @click="hideModal">
      CANCEL
    </b-button>

    <b-modal
      ref="tagRef"
      title="Set Recurring Issuance"
      centered
      cancel-disabled
      footer-class="border-0"
      size="md"
      no-close-on-backdrop
    >
      <b-container fluid>
        <b-row v-if="itemSelected">
          <b-col cols="12">
            <p class="text-body font-weight-bolder mb-0">Issuance Type</p>
            <v-select
              v-model="selectedIssuanceType"
              :options="issuanceType"
              :reduce="(val) => val"
              :clearable="false"
              class="w-100"
            />
          </b-col>
          <b-col
            v-if="selectedIssuanceType.value === '2'"
            cols="12"
            class="mt-1"
          >
            <p class="text-body font-weight-bolder mb-0">Every</p>
            <b-input-group prepend="Days">
              <b-form-input
                v-model="itemSelected.intervalDays"
                id="inline-form-input-username"
                type="number"
                value="1"
              ></b-form-input>
            </b-input-group>
          </b-col>
          <b-col
            v-if="selectedIssuanceType.value === '3'"
            cols="12"
            class="mt-1"
          >
            <p class="text-body font-weight-bolder mb-0">Select Days</p>
            <div class="d-flex flex-wrap" style="gap: 8px">
              <div v-for="option in dayOfWeek" :key="option.value">
                <b-form-checkbox
                  v-model="itemSelected.weekdays"
                  :value="option.value"
                  :name="option.text"
                >
                  {{ option.value }}
                </b-form-checkbox>
              </div>
            </div>
          </b-col>
          <b-col
            v-if="selectedIssuanceType.value === '4'"
            cols="12"
            class="mt-1"
          >
            <p class="text-body font-weight-bolder mb-0">Day of Month</p>
            <v-select
              v-model="itemSelected.dayOfMonth"
              :options="days"
              :reduce="(val) => val.value"
              :clearable="false"
              class="w-100"
            />
          </b-col>

          <template v-if="selectedIssuanceType.value === '5'">
            <b-col cols="12" class="mt-1">
              <p class="text-body font-weight-bolder mb-0">Occurrence</p>
              <v-select
                v-model="itemSelected.occurrence"
                :options="occurrences"
                :reduce="(val) => val.value"
                :clearable="false"
                class="w-100"
              />
            </b-col>
            <b-col cols="12" class="mt-1">
              <p class="text-body font-weight-bolder mb-0">Day of Week</p>
              <v-select
                id="dayOfWeek"
                v-model="itemSelected.weekday"
                :options="dayOfWeek"
                :reduce="(val) => val.value"
                class="w-100"
              />
            </b-col>
          </template>
          <b-col
            v-if="selectedIssuanceType.value === '6'"
            cols="12"
            class="mt-1"
          >
            <p class="text-body font-weight-bolder mb-0">Select Date</p>
            <flat-pickr
              id="date"
              v-model="date"
              class="form-control"
              :config="configDate"
              placeholder="mm/dd/yyyy"
            />
          </b-col>
          <b-col cols="12" class="mt-1">
            <p class="text-body font-weight-bolder mb-0">Number of Tokens</p>
            <b-form-input
              v-model="itemSelected.tokenPerIssuances"
              type="number"
              placeholder="Enter amount"
              value="1"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 mt-3">
          <b-button
            @click="refreshRecurring"
            variant="outline-secondary"
            class="ml-auto mr-1"
            >Cancel</b-button
          ><b-button
            :disabled="checkDisableSetRecurringIssuance()"
            variant="primary"
            @click="handleSaveIssuance"
            >Save</b-button
          >
        </b-row>
      </template>
    </b-modal>
  </b-modal>
</template>

<script>
import Spinner from "@/@core/components/Spinner.vue";
import useToastHandler from "@/services/toastHandler";
import {
  BButton,
  BModal,
  BFormGroup,
  BFormSelect,
  BFormSelectOption,
  BFormTextarea,
  BIconGift,
  BRow,
  BCol,
  BFormInput,
  BInputGroup,
} from "bootstrap-vue";
import { mapActions, mapState } from "vuex";
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import { formatDateSend } from "@/helpers/utils";

export default {
  components: {
    BButton,
    BModal,
    BFormGroup,
    BFormSelect,
    BFormSelectOption,
    BFormTextarea,
    BIconGift,
    Spinner,
    BRow,
    BCol,
    flatPickr,
    BFormInput,
    BInputGroup,
    vSelect,
  },
  data() {
    const options = [{ value: null, text: "Select Odds Boost" }];
    return {
      option: null,
      description: "",
      amount: null,
      type: null,
      options,
      form: {
        name: "",
        code: "",
        description: "",
        openDate: "",
        closeDate: "",
        bonusExpiredDays: null,
        type: "deposit",
        maxDiscount: "",
        discountValue: "",
        subType: null,
      },
      optionsType: [
        { label: "Yes - Accumulative", value: "Recurring Deposit" },
        { label: "No - Once Off Deposit", value: "One-time Deposit" },
      ],
      max: 4,
      value: 2,
      configDate: {
        enableTime: true,
        enableSeconds: true,
        altInput: true,
        altFormat: "d-m-Y H:i:S",
        dateFormat: "Y-m-d H:i:S",
        static: true,
      },
      issuanceType: [
        { label: "Daily", value: "1", type: "every-x-days" },
        { label: "Every X Days", value: "2", type: "every-x-days" },
        { label: "Weekly (Selected Days)", value: "3", type: "weekly" },
        { label: "Monthly (Specific Date)", value: "4", type: "monthly" },

        {
          label: "Monthly (First/Last Day of Week)",
          value: "5",
          type: "monthly-weekday",
        },
        // {
        //   label: "Monthly (Calendar Selection)",
        //   value: "6",
        //   type: "monthly-weekday",
        // },
      ],
      selectedIssuanceType: {
        label: "Daily",
        value: "1",
        type: "every-x-days",
      },
      dayOfWeek: [
        { label: "Monday", value: "mon", id: 1 },
        { label: "Tuesday", value: "tue", id: 2 },
        { label: "Wed", value: "web", id: 3 },
        { label: "Thursday", value: "thu", id: 4 },
        { label: "Friday", value: "fri", id: 5 },
        { label: "Saturday", value: "sat", id: 6 },
        { label: "Sunday", value: "sun", id: 7 },
      ],
      occurrences: [
        { label: "First", value: "1", text: "first" },
        { label: "Second", value: "2", text: "second" },
        { label: "Third", value: "3", text: "third" },
        { label: "Fourth", value: "4", text: "fourth" },
        { label: "Last", value: "5", text: "last" },
      ],
      days: [],
      itemSelected: {
        profileSegment: "User",
        recurrence: "No set",
        type: "every-x-days",
        intervalDays: 1,
        weekdays: [],
        weekday: "",
        dayOfMonth: null,
        occurrence: null,
        tokenPerIssuances: null,
      },
    };
  },
  watch: {
    option(val) {
      if (val) {
        const item = this.options.find((i) => i.id === val);
        this.description = item.description;
        this.type = item.discountType;
        this.amount = item.discountValue;
      }
    },
  },
  async created() {
    await this.fetchPromotionList();
  },
  computed: {
    ...mapState("promotions/list", ["loadingCreatePromotion"]),
  },
  methods: {
    ...mapActions({
      getPromotionsList: "promotions/list/getPromotionsList",
      getDetailPromotion: "promotions/list/getDetailPromotion",
      updatePromotionTargets: "promotions/list/updatePromotionTargets",
      createNewPromotion: "promotions/list/createNewPromotion",
      fetchUser: "user/detail/asyncUser",
    }),
    async fetchPromotionList() {
      const data = await this.getPromotionsList({
        page: 1,
        limit: 100,
        type: "Boost",
        onlyActive: true,
      });

      if (!data)
        return this.showToastError(false, "Error fetching promotion list");
      const list = data.data.map((i) => {
        return {
          ...i,
          value: i.id,
          text: i.name,
        };
      });
      this.options = [{ value: null, text: "Select Odds Boost" }, ...list];
    },
    async handleApplyPromotion() {
      const item = this.options.find((i) => i.id === this.option);
      const listWeekdays = !!this.itemSelected.weekday
        ? [this.itemSelected.weekday]
        : this.itemSelected.weekdays;
      const res = await this.updatePromotionTargets({
        promotionId: this.option,
        targets: [
          {
            targetType: "User",
            targetId: this.$router.currentRoute.params.id,
            recurring: {
              type: this.itemSelected.type,
              ...(!!this.itemSelected.intervalDays &&
                this.itemSelected.type === "every-x-days" && {
                  intervalDays: Number(this.itemSelected.intervalDays),
                }),
              ...(!!this.itemSelected.dayOfMonth && {
                dayOfMonth: Number(this.itemSelected.dayOfMonth),
              }),
              ...(!!this.itemSelected.occurrence && {
                occurrence: Number(this.itemSelected.occurrence),
              }),
              tokenPerIssuances: Number(this.itemSelected.tokenPerIssuances),
              startDate: item.startTime.slice(0, -5),
              endDate: item.endTime.slice(0, -5),
              ...(Array.isArray(listWeekdays) &&
                listWeekdays.length > 0 && {
                  weekdays: listWeekdays.map((day) => {
                    const dayItem = this.dayOfWeek.find((d) => d.value === day);
                    return dayItem.id;
                  }),
                }),
            },
          },
        ],
      });
      if (res) {
        this.showToastSuccess(true, "Applied successfully!");
        this.hideModal();
        this.fetchUser({ id: this.$router.currentRoute.params.id });
      }
    },
    hideModal() {
      this.$bvModal.hide("apply-boots-token-modal");
      this.option = null;
      this.description = "";
      this.type = null;
      this.amount = null;
    },
    checkDisableSetRecurringIssuance() {
      return (
        !this.itemSelected.tokenPerIssuances ||
        (this.itemSelected.type === "every-x-days" &&
          !this.itemSelected.intervalDays) ||
        (this.itemSelected.type === "weekly" &&
          (!this.itemSelected.weekdays ||
            !this.itemSelected.weekdays.length)) ||
        (this.itemSelected.type === "monthly" && !this.itemSelected.dayOfMonth)
      );
    },
    refreshRecurring() {
      this.selectedIssuanceType = {
        label: "Daily",
        value: "1",
        type: "every-x-days",
      };
      this.itemSelected = {
        profileSegment: "",
        recurrence: "No set",
        type: "every-x-days",
        intervalDays: 1,
        weekdays: [],
        weekday: "",
        dayOfMonth: null,
        occurrence: null,
        tokenPerIssuances: null,
      };
      this.$refs.tagRef.hide();
    },
    handleSaveIssuance() {
      if (!this.itemSelected.type) {
        this.itemSelected.type === "every-x-days";
        this.itemSelected.intervalDays = 1;
      }
      this.itemSelected = {
        ...this.itemSelected,
        recurrence:
          this.itemSelected.tokenPerIssuances +
          " token(s) " +
          this.formatText(this.itemSelected),
      };
      this.$refs.tagRef.hide();
      // this.refreshRecurring();
    },
    formatText(item) {
      switch (item.type) {
        case "every-x-days":
          return item.intervalDays === 1
            ? "daily"
            : `every ${item.intervalDays} days`;
        case "weekly":
          return `weekly (${item.weekdays.join(", ")})`;
        case "monthly":
          return "monthly on the " + getOrdinalSuffix(Number(item.dayOfMonth));
        case "monthly-weekday":
          const occurrence = this.occurrences.find(
            (i) => i.value === item.occurrence
          );
          const weekday = this.dayOfWeek.find((i) => i.value === item.weekday);
          return `monthly on the ${occurrence.text} ${weekday.label}`;
        default:
          return "daily";
      }
    },
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();
    return {
      showToastError,
      showToastSuccess,
      formatDateSend,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
